import { render } from "./ClaimAdd.vue?vue&type=template&id=79be0f1a&scoped=true"
import script from "./ClaimAdd.vue?vue&type=script&lang=js"
export * from "./ClaimAdd.vue?vue&type=script&lang=js"

import "./ClaimAdd.vue?vue&type=style&index=0&id=79be0f1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79be0f1a"]])

export default __exports__